import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';

import {Subscription} from 'rxjs';

import {EntitiesComponent} from '../../../entities.component';

import {LoginService} from '../../../../pages/login/login.service';
import {UserService} from '../../../../shared/service/user.service';
import {AuthService} from '../../../../shared/service/auth.service';
import {NotificationService} from '../../../../shared/service/notification.service';
import {AppSubject} from '../../../../shared/app-subject';
import {Severity, ToastService} from '../../../../shared/components/toast/toast.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnInit, OnDestroy {

  @Input() activeModule?: string;

  AuthService = AuthService;

  user: any;
  displayName?: string;

  decreeAndCircularUsing?: string;

  changingPassword?: boolean;
  submittedPassword?: boolean;
  changePasswordForm = this.fb.group({
    oldPassword: ['', Validators.required],
    newPassword: ['', Validators.required],
    newPasswordVerify: ['', Validators.required]
  });
  changePasswordError?: string;

  decreeCircularSubscription?: Subscription;

  logoData: any;

  baseWebSocketURL: string = environment.baseWebSocketURL;
  noticeCount?: number;
  notifications?: Array<any>;
  notification: any;
  titleText?: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public entities: EntitiesComponent,
    private loginService: LoginService,
    private notificationService: NotificationService,
    private toastService: ToastService
  ) {
  }

  ngOnInit(): void {

    this.logoData = UserService.get('user-logo');

    this.user = UserService.getUser();
    this.decreeCircularSubscription = AppSubject.getDecreeCircular().subscribe((decreeCircular) => {
      this.decreeAndCircularUsing = decreeCircular;
    });
    if (AuthService.hasRoles(['Customer'])) {
      this.displayName = this.user.partyTaxId;
    } else {
      this.displayName = this.user.partyName;
    }

    this.initWebSocket();
    this.getNotificationCount();
  }

  ngOnDestroy(): void {
    if (this.decreeCircularSubscription) {
      this.decreeCircularSubscription.unsubscribe();
    }
    if (this.webSocket) {
      this.webSocket.close(3010, 'unmount');
    }
  }

  changePassword(): void {
    this.changePasswordForm.reset();
    this.changingPassword = true;
  }

  onChangePassword(): void {
    if (!this.submittedPassword && this.changePasswordForm.valid) {
      this.submittedPassword = true;
      this.changePasswordError = '';

      this.loginService.changePassword(this.changePasswordForm.value).subscribe(({isSuccess, messages}) => {
        this.submittedPassword = false;
        if (isSuccess === 'Y') {
          this.toastService.setMessage({severity: Severity.SUCCESS, detail: messages});
          this.changingPassword = false;
        } else {
          this.changePasswordError = messages;
        }
      }, () => {
        this.submittedPassword = false;
      });
    }
  }

  logout(): void {
    this.loginService.logout().subscribe(() => {
      this.router.navigateByUrl('/login').then();
    });
  }

  webSocket: any;

  initWebSocket(): void {
    const origin = location.origin.replace('http', 'ws').replace('https', 'wws');
    this.webSocket = new WebSocket(`${origin}/${this.baseWebSocketURL}`);
    this.webSocket.addEventListener('open', () => {
      this.webSocket?.send('subscribe:CustomerNotification');
    });

    this.webSocket.onclose = (e: any) => {
      if (e.reason !== 'unmount') {
        this.initWebSocket();
      }
    }
    this.webSocket.onmessage = (event: any) => {
      const data = JSON.parse(event.data);
      if (data.topic === 'CustomerNotification') {
        this.getNotificationCount();
      }
    }
  }

  getNotificationCount(): void {
    this.notificationService.getCount().subscribe(data => {
      this.noticeCount = data?.noticeCount;
    });
  }

  viewNotification(event: any): void {
    this.entities.onTopbarActionClick(event, 'Notification');

    this.notificationService.markTouched().subscribe(() => this.getNotificationCount());

    const escape = document.createElement('div');

    this.notificationService.getList().subscribe(data => {
      data?.listData.forEach((item: any) => {
        escape.innerHTML = item.titleText;
        item.titleText = escape.innerText;
      });
      this.notifications = data?.listData;
    });
  }

  viewNotificationDetail(notification: any): void {
    this.notification = notification;
    this.titleText = notification.titleText
  }

}
